import { useContext } from "react";
import { BSTInsightsAppContext } from "../../../layouts/PageLayout";
import { RolesEnum } from "../../../utils/roles";

export const useNLMThresholdSettings = () => {
  const { UserRoles } = useContext(BSTInsightsAppContext);

  const hasAccountOwnerRole = UserRoles.some(
    (item) => item.roleId === RolesEnum.AccountOwner
  );

  const hasProjectAdministrator = UserRoles.some(
    (item) => item.roleId === RolesEnum.ProjectAdministrator
  );

  return {
    hasAccountOwnerRole,
    hasProjectAdministrator,
  };
};
